import { isAuthExpiredError } from '../authErrors'
import { API_BASE_URL, buildProtectedAuthHeaders, fetchWithTimeout, readApiError, throwIfAuthRejected } from './client'

export interface DisclaimerStatus {
  required: boolean
  /** Custom per-binder disclaimer texts; empty means show the default text. */
  texts: string[]
}

const ENDPOINT = `${API_BASE_URL}/v1/me/disclaimer`

export async function fetchDisclaimerStatus(): Promise<DisclaimerStatus> {
  try {
    const headers = await buildProtectedAuthHeaders('fetch disclaimer status', {
      'Content-Type': 'application/json',
    })
    const response = await fetchWithTimeout(
      ENDPOINT,
      { method: 'GET', headers },
      8_000,
    )
    throwIfAuthRejected(response, 'fetch disclaimer status')
    if (!response.ok) {
      const problem = await readApiError(response)
      throw new Error(problem.message || problem.error)
    }
    const body = (await response.json()) as {
      required?: unknown
      texts?: unknown
    }
    return {
      required: body.required !== false,
      texts: Array.isArray(body.texts)
        ? body.texts.filter((text): text is string => typeof text === 'string')
        : [],
    }
  } catch (error) {
    if (isAuthExpiredError(error)) {
      throw error
    }
    throw error instanceof Error ? error : new Error(String(error))
  }
}
